import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-[100vh] p-5 pt-4 pb-0">
      <Header />
      <Outlet />
    </div>
  );
};

export default Layout;
